/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import "./kanbanStyles.css";
import { useEffect, useState } from "react";

// @asseinfo/react-kanban components
import Board, { moveCard } from "@asseinfo/react-kanban";

// html-react-parser
import parse from "html-react-parser";

// uuid is a library for generating unique id
import { v4 as uuidv4 } from "uuid";

// @mui material components
import { Theme } from "@mui/material/styles";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import Card from "layouts/applications/kanban/components/Card";
import { useMaterialUIController } from "context";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Grid, Icon, Modal, TextField, Typography } from "@mui/material";
import Zoom from 'react-medium-image-zoom'
import { CategoryDto, CreatedBy, Grades, grades, QuizDto, SubCategoryDto, Subjects } from "types";
import { getCategories, getMySubjects } from "services/category-services";
import { getByCategory } from "services/sub-category-services";
import { eraseRichText, generateQrCode, getUUIDFromKey } from "utils/helpers";
import PopOver from 'components/PopOver';
import { getQuizzesByCategory } from "services/quiz-services";
import MDBadge from "components/MDBadge";
import linearGradient from "assets/theme/functions/linearGradient";
import MDButton from "components/MDButton";
import Logo from '../../../assets/images/logo.svg'
import { createCardCollections, updateCardCollections } from 'services/card-collection-services';
import MDInput from 'components/MDInput';
import { useLocation } from 'react-router-dom';
import { logo } from './logo';
// import { createUpdatePlaySession } from 'services/play-session-services';
import config from 'config';
import { useAppContext } from 'context/app-context';
import { Howl } from 'howler';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  maxHeight: 'calc(100vh - 100px)',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

interface ICard {
  id: string;
  template: JSX.Element;
}

interface IColumn {
  id: string;
  title: string;
  cards: ICard[];
}

interface IBoard {
  columns: IColumn[];
}

interface SubCategoryDtoWithHasAudioAndPicture extends SubCategoryDto {
  hasPicture: boolean
  hasAudio: boolean
}

function Kanban(): JSX.Element {
  const location = useLocation()
  const [categories, setCategories] = useState<CategoryDto[]>([]);
  const [subCategories, setSubCategories] = useState<SubCategoryDtoWithHasAudioAndPicture[]>([]);
  const [boards, setBoards] = useState<IBoard>({
    columns: [
      //@ts-ignore
      { id: "column0", key: uuidv4(), title: "Mulige kategorier", cards: [] },
      {
        //@ts-ignore
        id: "column1", key: uuidv4(), title: "Valgte kategorier", cards: [],
      },
    ],
  });
  const { quizCards, categories: categoriesFromContext, handleMessage } = useAppContext()
  
  useEffect(() => {
    (async () => {
      if (location.state){ //@ts-ignore
        //@ts-ignore
          setCategoryValue(categoriesFromContext.filter((c: any) =>location.state?.cardCollection?.categories?.includes(c.PK) )) //@ts-ignore
      }
  })()
  }, [location, categoriesFromContext]) //@ts-ignore
  const [name, setName] = useState(location.state?.cardCollection.name || undefined)
  const [imageUrl, setImageUrl] = useState('')

  const [isOpen, setIsOpen] = useState(false)

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;


  const createdBy = ['QuizEdu', 'Mig', 'Andre']
  //@ts-ignore
  const [createdByValue, setCreatedByValue] = useState<string | null>(location.state?.cardCollection.createdBy ||null);
  const [inputCreatedByValue, setInputCreatedByValue] = useState("");
  const [categoryValue, setCategoryValue] = useState<CategoryDto[]>([]);//@ts-ignore
  const [subjectValue, setSubjectValue] = useState<Subjects[]>(location.state?.cardCollection.subjects || []);
  const [inputSubjectValue, setInputSubjectValue] = useState("");//@ts-ignore
  const [gradeValue, setGradeValue] = useState<Grades[]>(location.state?.cardCollection.grades || []);
  const [inputGradeValue, setInputGradeValue] = useState("");
  const [pickedColumn, setPickedColumn] = useState<IColumn>({} as IColumn);
  const [subjects, setSubjects] = useState<string[]>([]);
  const [hasLoaded, setHasLoaded] = useState(false)

  useEffect(() => {
    let subcategories
    if (Object.keys(categoryValue).length) {
      const foundCategories: CategoryDto[] = []
      for (const category of categoryValue) {
        foundCategories.push(category)
      }
      (async () => {
        // console.log({foundCategories})
        subcategories = await getByCategory(foundCategories.map(c => getUUIDFromKey(c.PK)).join(',')) as SubCategoryDtoWithHasAudioAndPicture[]
        for (const subCategory of subcategories) {
          const cards = quizCards.filter((q: QuizDto) => q.subcategory.subcategory === subCategory.PK)
          Object.assign(subCategory, {
            hasPicture: cards.some((q: QuizDto) => q.descriptionImage || q.answerImage), 
            hasAudio: cards.some((q: QuizDto) => q.descriptionAudio || q.answerAudio)  
          })
        }//@ts-ignore 
        setSubCategories(subcategories)
        if (!hasLoaded && subcategories.length) {
          for (const subCategory of subcategories) {
            const cards = quizCards.filter((q: QuizDto) => q.subcategory.subcategory === subCategory.PK)
            Object.assign(subCategory, {
              hasPicture: cards.some((q: QuizDto) => q.descriptionImage || q.answerImage), 
              hasAudio: cards.some((q: QuizDto) => q.descriptionAudio || q.answerAudio)  
            })
          } //@ts-ignore
          const notPickedCards = subcategories.filter(c => !location.state?.cardCollection?.subCategories.includes(c.PK))
            .map((c) => ({
              id: c.PK,
              template: (
                <Card
                  hasAudio={c.hasAudio}
                  hasPicture={c.hasPicture}
                  badge={{ color: "transparent", label: "" }}
                  content={c.name}
                  members={[]}
                />
              ),
            }));    
            //@ts-ignore
            const pickedCards = subcategories.filter(c => location.state?.cardCollection?.subCategories.includes(c.PK))//@ts-ignore
            .sort((a, b)=> location.state?.cardCollection?.subCategories.indexOf(a.PK) - location.state?.cardCollection?.subCategories.indexOf(b.PK))
            .map((c, index) => ({
              id: c.PK,
              template: (
                <Card
                  hasAudio={c.hasAudio}
                  hasPicture={c.hasPicture}
                  // key={c.PK}
                  badge={{ color: colors[index], label: "" }}
                  content={c.name}
                  members={[]}
                />
              ),
            }));
          setBoards({
            columns: [
              //@ts-ignore
              { id: "column0", title: "Mulige kategorier", cards: notPickedCards },
      
              //@ts-ignore
              { id: "column1", title: "Valgte kategorier", cards: pickedCards },
            ],
          });
          setHasLoaded(true)
        } else {
      
            const mappedCards = subcategories
              .filter(card => !pickedColumn.cards?.map(card => card.id).includes(card.PK))
              .map((c) => ({
                id: c.PK,
                template: (
                  <Card
                    key={c.PK}
                    hasAudio={c.hasAudio}
                    hasPicture={c.hasPicture}
                    badge={{ color: "transparent", label: "" }}
                    content={c.name}
                    members={[]}
                  />
                ),
              }));
            setBoards({
              columns: [
                //@ts-ignore
                { id: "column0", title: "Mulige kategorier", cards: mappedCards },
        
                //@ts-ignore
                boards?.columns[1] ?? [],
              ],
            });
        }
      })()
    } else {
      setSubCategories([])
    }
  }, [subCategories.length, categoryValue, categories ]);

  // useEffect(() => {

  // }, [categoryValue, categories])

  useEffect(() => {
    if (createdByValue && Object.keys(subjectValue).length && gradeValue) {
      (async () => {
        const categories = await getCategories(subjectValue, gradeValue, createdByValue.toLocaleLowerCase()) //@ts-ignore
        setCategories(categories.filter(sub => !location.state?.cardCollection?.categories.includes(sub.PK)));
      })();
    }
  }, [subjectValue, gradeValue, createdByValue])


  const colors = ["#ffe12a", "#f54c5b", "#cb6efe", "#8fdc9c", "#00b9f8", "#ff8445"];


  const handleChooseSubjects = (card: any, source: any, destination: any) => {
    if (
      Object.keys(pickedColumn).length &&
      pickedColumn?.cards.length > 5 &&
      destination.toColumnId === "column1" &&
      source.fromColumnId === "column0"
    ) {
      handleMessage("Du kan have op til 6 kategorier", "error");
      return;
    }
    const updatedBoards = moveCard(boards, source, destination) as IBoard;
    const [firstColumn, secondColumn] = updatedBoards.columns;
    setPickedColumn(secondColumn as IColumn);
    setBoards({
      ...updatedBoards,
      columns: [
        {
          ...firstColumn,
          cards: firstColumn.cards.map((c) => ({
            ...c,
            template: {
              ...c.template,
              props: {
                ...c.template.props,
                badge: { ...c.template.props.badge, color: "transparent" },
              },
            },
          })),
        },
        {
          ...secondColumn,
          cards: secondColumn.cards.map((c, index: number) => ({
            ...c,
            template: {
              ...c.template,
              props: {
                ...c.template.props,
                badge: { ...c.template.props.badge, color: colors[index] },
              },
            },
          })),
        },
      ],
    });
  };

  useEffect(() => {
    (async () => {
      setSubjects(await getMySubjects(gradeValue));
    })();
  }, [gradeValue]);

  useEffect(() => {
    // window.onload = function () {
    const selectedColumn = document.querySelector(
      '[data-rbd-draggable-id="column-draggable-column1"]'
    ) as HTMLElement;
    selectedColumn.classList.add("teste");
    const divContainer = document.createElement("div");
    divContainer.innerHTML = logo

    divContainer.classList.add("center-text");
    selectedColumn.appendChild(divContainer);
    // }
  }, []);

  const [open, setOpen] = useState(false)
  const [groupedQuizzesBySubCategory, setGroupedQuizzesBySubCategory] = useState<any[] | null>(null)
  const [categorySelected, setCategorySelected] = useState('') //@ts-ignore
  const [pk, setPk] = useState(getUUIDFromKey(location.state?.cardCollection?.PK ||''))

  const handleClick = async (categoryName: string) => {
    setOpen(!open)
    const categorySelected = categories.find(c => c.name === categoryName)
    setCategorySelected(categoryName)
    setGroupedQuizzesBySubCategory(await getQuizzesByCategory(getUUIDFromKey(categorySelected.PK)))
  }

  const getCreatedByValue = (str: string): CreatedBy => {
      switch (str) {
        case 'QuizEdu':
          return CreatedBy.QuizEdu
        case 'Mig':
          return CreatedBy.Mig
        case 'Andre':
          return CreatedBy.Andre
        default:
          return null
      }
  }

  const handleSaveQuizCardGame = async () => {
    try {
      const newPk = await createCardCollections({
        name,
        jokerCard: false,
        subCategories: pickedColumn.cards.map(card => card.id),
        createdBy: getCreatedByValue(createdByValue),
        categories: categoryValue.map(category => category.PK),
        grades: gradeValue,
        subjects: subjectValue
      })
      setPk(newPk)

      // await createUpdatePlaySession(newPk, uuidv4(), {})
      handleMessage('Du har oprettet en kortsamling', 'success')
      generateQrCode(
        `${(config.API.address)}/kort/${newPk}`
        , setImageUrl)
    } catch (error) { //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, "error");
    }
  }
 const handleUpdateQuizCardGame = async () => {
  const categoryPks = subCategories.filter(sub => pickedColumn.cards.map(card => card.id).includes(sub.PK)).map(sub => sub.SK)
    try {
      const cardCollection = await updateCardCollections(pk,  {
        name,
        jokerCard: false,
        subCategories: pickedColumn.cards.map(card => card.id),
        createdBy: getCreatedByValue(createdByValue),
        categories: [...new Set(categoryPks)],
        grades: gradeValue,
        subjects: subjectValue
      })
      setPk(getUUIDFromKey(cardCollection.PK))

      // await createUpdatePlaySession(getUUIDFromKey(cardCollection.PK), getUUIDFromKey(cardCollection.PK), {})
      handleMessage('Du har oprettet en kortsamling', 'success')
      generateQrCode(
        `${(config.API.address)}/kort/${getUUIDFromKey(cardCollection.PK)}`
        , setImageUrl)
    } catch (error) { //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, "error");
    }
  }


  const playQuizCards = () => {
    if (pk) {
      window.open(`/kort/${pk}`, '_blank')
    } else {
      handleMessage('Du skal først oprette et spil for at spille det', 'info')
    }
  }
  // const [scanResultFile, setScanResultFile] = useState('')
  // const [promptedCameraAccess, setPromptedCameraAccess] = useState(false)

  const [playingSound, setPlayingSound] = useState(false)
  const [sound, setSound] = useState<Howl>(null as Howl)

  useEffect(() => {
    if (sound){
      setPlayingSound(!playingSound)
      try {
        if (!playingSound) {
          sound.play()
        } else {
          sound.stop()
        }
      } catch (error) {
        handleMessage("Der er ingen lyd til denne quiz", 'info')
      }
      setSound(null)
    }
  }, [sound])
  

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox display="flex" justifyContent="flex-end" m={2}>
          {/* <Header /> */}
        </MDBox>
        <MDBox
          position="relative"
          my={4}
          sx={({
            palette: { light, background },
            functions: { pxToRem },
            borders: { borderRadius },
          }: Theme | any) => ({
            "& .react-kanban-column": {
              backgroundColor: darkMode ? background.card : light.main,
              width: pxToRem(450),
              margin: `0 ${pxToRem(10)}`,
              padding: pxToRem(20),
              borderRadius: borderRadius.lg,
            },
          })}
        >
          <Grid container gap={1}>
            <Grid item lg={7} sm={12}>
              <MDBox
                minWidth={320}>
                <Autocomplete
                  noOptionsText="Ingen muligheder endnu"
                  multiple
                  filterSelectedOptions
                  value={gradeValue}
                  onChange={(event: any, newValue: string[]) => {
                    setGradeValue(newValue);
                  }}
                  inputValue={inputGradeValue}
                  onInputChange={(event, newInputValue) => {
                    if (newInputValue === "") {
                      setBoards({
                        columns: [
                          //@ts-ignore
                          { id: "column0", key: "column0", title: "Mulige kategorier", cards: [] },
                          //@ts-ignore
                          boards.columns[1]
                        ],
                      });
                      setCategoryValue([])
                    }
                    setInputGradeValue(newInputValue);
                    setPickedColumn({} as IColumn);
                  }}
                  id="controllable-states-grades"
                  options={grades.slice(3)}
                  sx={{ width: 320 }}
                  renderInput={(params) => <TextField {...params} label="Klassetrin" />}
                />
              </MDBox>
              <MDBox mt={3}>
                <Autocomplete
                  noOptionsText="Ingen muligheder endnu"
                  multiple
                  filterSelectedOptions
                  value={subjectValue}
                  onChange={(event: any, newValue: string[]) => {
                    setSubjectValue(newValue);
                  }}
                  inputValue={inputSubjectValue}
                  onInputChange={(event, newInputValue) => {
                    if (newInputValue === "") {
                      setBoards({
                        columns: [
                          //@ts-ignore
                          { id: "column0", key: "column0", title: "Mulige kategorier", cards: [] },
                          //@ts-ignore
                          boards.columns[1]
                        ],
                      });
                      setCategoryValue([])
                    }
                    setInputSubjectValue(newInputValue);
                    setPickedColumn({} as IColumn);
                  }}
                  id="controllable-states-subjects"
                  options={subjects}
                  sx={{ width: 320 }}
                  renderInput={(params) => <TextField {...params} label="Fag/Emner" />}
                />
              </MDBox>
              <MDBox mt={3}>
                <Autocomplete
                  noOptionsText="Ingen muligheder endnu"
                  value={createdByValue}
                  onChange={(event: any, newValue: string | null) => {
                    setCreatedByValue(newValue);
                  }}
                  inputValue={inputCreatedByValue}
                  onInputChange={(_event, newInputValue) => {
                    if (newInputValue === "") {
                      setBoards({
                        columns: [
                          //@ts-ignore
                          { id: "column0", key: "column0", title: "Mulige kategorier", cards: [] },
                          //@ts-ignore
                          boards.columns[1]
                        ],
                      });
                      setCategoryValue([])
                    }
                    setInputCreatedByValue(newInputValue);
                    setPickedColumn({} as IColumn);
                  }}
                  id="controllable-states-official-mine-from-other-users"
                  options={createdBy}
                  sx={{ width: 320 }}
                  renderInput={(params) => <TextField {...params} label="Lavet af?" />}
                />
              </MDBox>
              <MDBox mt={3}>
                <Autocomplete
                  multiple
                  noOptionsText="Intet resultat i denne kategori"
                  filterSelectedOptions
                  getOptionLabel={(option) => (option as CategoryDto).name || ""}
                  //@ts-ignore
                  value={categoryValue}
                  //@ts-ignore
                  onChange={(event: SyntheticEvent<Element, Event>, newValue: CategoryDto[]) => {
                    // // const set = new Set([...categories.map(c => c.PK), ...categoryValue.map((c) => c.PK)]);
                    // // console.log(set)
                    // const difference = [...new Set([...categoryValue.map(c=>c.PK), ...categories.map(c => c.PK)])].filter(x => location.state?.cardCollection?.categories.includes(x));
                    // console.log({difference})
                    //  if (difference.length !== location.state?.cardCollection?.categories.length) {
                    //   // console.log('runs! difference')
                     
                    //   setCategories([...newValue, ...categories, ...categoryValue])
                    // }
                    setCategoryValue(newValue);
                    // setBoards({
                    //   columns: [
                    //     //@ts-ignore
                    //     { id: "column0", key: "column0", title: "Mulige kategorier", cards: [] },
                    //     //@ts-ignore
                    //     { id: "column1", key: "column1", title: "Valgte kategorier", cards: [] },
                    //   ],
                    // });
                    // setPickedColumn({} as IColumn);
                  }}
                  // inputValue={inputCategoryValue}
                  onInputChange={(_event, newInputValue) => {
                    if (Object.keys(newInputValue).length === 0) {
                      setBoards({
                        columns: [
                          //@ts-ignore
                          { id: "column0", key: "column0", title: "Mulige kategorier", cards: [] },
                          //@ts-ignore
                          boards.columns[1]
                          // { id: "column1", key: "column1", title: "Valgte kategorier", cards: [] },
                        ],
                      });
                    }

                  }}
                  id="controllable-states-categories"
                  options={categories}
                  sx={{ width: 320 }}
                  open={isOpen}
                  onOpen={() => setIsOpen(true)}
                  onClose={(e, reason) => {
                    if (reason === "blur") return;
                    setIsOpen(false);
                  }}
                  renderInput={(params) => <TextField {...params} label="Kategori" />}
                  renderOption={(props, label) =>
                    <PopOver
                      // hasAudio={label.hasAudio}
                      // hasPicture={label.hasPictures}
                      handleClick={() => handleClick(label.name)}
                      {...props}
                      id={props.id}
                      label={label.name}
                      message={label.name}
                    />}
                />
              </MDBox>
            </Grid>
            <Grid item lg={4} sm={12}>
              <Box>
                <Grid container>
                  <Grid item lg={12}>
                    <Box
                      minWidth={320}
                      width='100%'
                      minHeight='300px'
                      height='100%'
                      display='flex'
                      flexDirection='column'
                      justifyContent='start'
                    >
                      <MDBox
                        display='flex'
                        flexDirection='column'
                        alignItems='center'
                      >
                        <MDInput
                          height={60}
                          aria-required
                          fullWidth
                          label="Titel på kort"
                          value={name}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setName(e.target.value)
                          }}
                        />
                        <MDBox
                          width='100%'
                          display='flex'
                          justifyContent='space-evenly'
                        >
                          <MDButton
                            sx={{
                              marginTop: 2,
                              marginBottom: 3,
                              paddingLeft: 3,
                              paddingRight: 3,
                            }}
                            onClick={()=>{
                              if (location.state){
                                handleUpdateQuizCardGame()
                              } else {
                                handleSaveQuizCardGame()
                            }
                            }}
                          >
                            <Icon id='icon-large-font-save' fontSize="large">save</Icon>
                            <Typography>Gem</Typography>
                          </MDButton>
                          <MDButton
                            sx={{
                              marginTop: 2,
                              marginBottom: 3,
                              paddingLeft: 3,
                              paddingRight: 3,
                            }}
                            onClick={playQuizCards} >
                            <Icon id='icon-large-font-play' fontSize="large">play_arrow</Icon>
                            <Typography>Start</Typography>
                          </MDButton>
                        </MDBox>
                        {imageUrl ? <a href={imageUrl} download><img src={imageUrl} alt="play qrcode" /> </a> : null}
                      </MDBox>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
          {Object.keys(boards).length ? (
            <Board
              disableColumnDrag
              allowAddCard
              renderColumnHeader={({ id, title }: any, addCard: any) => (
                <>
                  <MDBox key={id} display="flex" justifyContent="center" alignItems="center" mb={3}>
                    <MDTypography variant="h4">{title}</MDTypography>
                  </MDBox>
                </>
              )}
              renderCard={({ id, template }: any, { dragging }: any) => (
                <MDBox
                  key={id}
                  dragging={dragging.toString() || undefined}
                  display="block"
                  width="calc(450px - 40px)"
                  bgColor={darkMode ? "transparent" : "white"}
                  color="text"
                  borderRadius="xl"
                  mt={2.5}
                  py={1.875}
                  px={1.875}
                  lineHeight={1.5}
                  sx={{
                    border: ({ borders: { borderWidth }, palette: { white } }: any) =>
                      darkMode ? `${borderWidth[1]} solid ${white.main}` : 0,
                    fontSize: ({ typography: { size } }: any) => size['2xl'],
                    color: ({ palette: { black } }) => black.main,
                  }}
                >
                  {typeof template === "string" ? parse(template) : template}
                </MDBox>
              )}
              onCardDragEnd={(board: any, card: any, source: any) =>
                handleChooseSubjects(board, card, source)
              }
            >
              {boards}
            </Board>
          ) : null}
        </MDBox>
      </MDBox >
      <Modal
        open={open}
        onClose={() => {
          setOpen(!open)
          setGroupedQuizzesBySubCategory(null)
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <MDBadge
              color='dark'
              badgeContent={categorySelected}
              size="lg"
              container
            />
          </div>
          {groupedQuizzesBySubCategory ? (Object.keys(groupedQuizzesBySubCategory).length ? groupedQuizzesBySubCategory.map(q => Object.values(q).map((v, index) =>
            <Accordion key={index}>
              <AccordionSummary
                expandIcon={<Icon sx={{ fontWeight: "bold" }}>expand_more</Icon>}//@ts-ignore
                aria-controls={`${v.name}-content`}//@ts-ignore
                id={`${v.name}-header`}
              >
                {/*@ts-ignore*/}
                {v.name}
              </AccordionSummary>
              <AccordionDetails style={{ display: 'flex', flexWrap: 'wrap' }}>
                {/*@ts-ignore*/}
                {v.values.map(value =>
                  <MDBox
                    key={value.id}
                    width={300}
                    bgColor={linearGradient('#7030A0', '#00B0F0', 0)}
                    py={3}
                    px={3}
                    m={2}
                    position='relative'
                    borderRadius='5rem'
                    border={`.5em solid white`}
                    boxShadow='0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important'
                    display='flex'
                    flexDirection='column'
                    justifyContent={'space-between'}
                  >
                    <div style={{ height: '100%' }}>
                      <MDTypography variant='h3' color='white' fontWeight='bold' textTransform="capitalize">{value.title}</MDTypography>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 5, padding: 10, border: '1px solid #ccc'}}>
                        {eraseRichText(value.description) && <div
                          style={{
                            paddingTop: 20,
                            paddingBottom: 20,
                            width: '100%',
                            color: 'white',
                            display: 'flex',
                            marginBottom: 15,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            paddingLeft: 15,
                            paddingRight: 15,
                            textAlign: 'start',
                          }}
                          dangerouslySetInnerHTML={
                            { __html: value.description as string }
                          } />}
                        {value.descriptionImage &&
                          <>
                            {/* <MDTypography color="white" fontWeight='bold'>Image:</MDTypography> */}
                            <Zoom>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <img
                                  style={{
                                    maxWidth: 150,
                                    maxHeight: 150,
                                    width: "auto"
                                  }}
                                  loading="lazy"
                                  alt="quiz img"
                                  src={value.descriptionImage}
                                />
                              </div>
                            </Zoom>
                          </>}
                        {value.descriptionAudio && <>
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <MDButton onClick={() => {
                              setSound(new Howl({
                                src: value.descriptionAudio,
                                html5: true,
                                onend: function () {
                                  setPlayingSound(false)
                                },
                              }))
                              }} iconOnly><Icon fontSize='large'>{playingSound ? 'stop' : 'play_arrow'}</Icon></MDButton>
                          </div>
                        </>} 
                        </div>
                      <div style={{ marginTop: 5, display: 'block', }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, padding: 10, border: '1px solid #ccc'}}>
                        {eraseRichText(value.answer) &&<div
                            style={{
                              flex: 1,
                              height: '100%',
                              color: 'white',
                              display: 'flex',
                              marginBottom: 5,
                              marginTop: 5,
                              flexDirection: 'column',
                              justifyContent: 'center',
                              textAlign: 'start',
                              }}
                            dangerouslySetInnerHTML={
                              { __html: value.answer }
                            } />}
                           {value.answerImage && <Zoom >
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                              <img
                                  style={{
                                    maxWidth: 150,
                                    maxHeight: 150,
                                    width: "auto"
                                  }}
                                  alt="quiz img"
                                  loading="lazy"
                                  src={value.answerImage}
                                />
                              </div>
                            </Zoom>}
                            {value.answerAudio && <>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <MDButton onClick={() => setSound(new Howl({
                                src: value.answerAudio,
                                html5: true,
                                onend: function () {
                                  setPlayingSound(false)
                                },
                              }))} iconOnly><Icon fontSize='large'>{playingSound ? 'stop' : 'play_arrow'}</Icon></MDButton>
                              </div>
                            </>}

                        </div>
                      </div>
                    </div>
                    <MDBox display={'flex'} justifyContent={'center'}><img src={Logo} alt='logo' /></MDBox>
                  </MDBox>
                )}

              </AccordionDetails>
            </Accordion>

          )) : <MDTypography variant="h4">Der er ikke oprettet nogen quiz for denne kategori endnu</MDTypography>) : null}

        </Box>

      </Modal>
    </DashboardLayout >
  );
}

export default Kanban;
